<template>
  <div>
    <bottom-bar :hideBotton="zap" :home="!zap"/>
    <div class="content" :class="{'c-zap': zap || modo_catalogo}">
      <loading v-if="load" fullscrean="true" text="Carregando os produtos"/>
      <div v-else>
        <div class="mb-4" v-if="!zap">
          <div class="container-capa shadow-sm">
            <div class="logo-empresa" :style="'background-image: url('+ (empresa.url_capa ? empresa.url_capa : base_cdn + '/static/imgs/default.png') +')'"></div>
          </div>
          <div class="container-logo text-center">
            <div class="text-home shadow-sm">
              <div class="img-empresa">
                <img class="shadow-sm" :class="{'bg-primary': !empresa.url_imagem}" :src="empresa.url_imagem ? empresa.url_imagem : base_cdn + '/static/imgs/default.png'" :alt="empresa.nome_fantasia">
              </div>
              <div class="small" v-if="id_theme === '1'" data-nosnippet>
                <span class="badge badge-success" v-if="empresa.ativo === '1' && empresa.aberto === '1'">ABERTO</span>
                <span class="badge badge-primary" v-else-if="empresa.empresaAberta">AGENDAMENTO</span>
                <span class="badge badge-danger" v-else>FECHADO</span>
              </div>
              <h1 class="h4 text-dark font-weight-bolder my-1">{{empresa.nome_fantasia}}</h1>
              <div class="d-flex flex-wrap align-items-center justify-content-center">
                <span class="small"><icon name="address" size="15" full="true" class="fi-2"/> {{ empresa.nome_cidade }} - {{ empresa.sigla_estado }}</span>
                <i class="i-point mx-2"></i>
                <router-link :to="`/${empresa.dominio_delivery}/info`" class="text-primary font-weight-bold small" data-nosnippet>Mais informações</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="mb-4" v-if="!modo_catalogo">
            <div v-if="empresa.ativo === '1' && empresa.aberto === '1'">
              <div v-if="zap && token">
                <router-link :to="'/' + empresa.dominio_delivery + '/pedidos'">
                  <card-info title="Acompanhe seus pedidos" class="mb-2" icon="pedido" icon-pos="fa-angle-right" :link="'/' + empresa.dominio_delivery + '/pedidos'">
                    <div class="small">Clique para visualizar</div>
                  </card-info>
                </router-link>
              </div>
              <div v-else>
                <a href="javascript:" v-if="sacola && sacola.origin === '4'" @click="clearSacola">
                  <card-info title="Pedido No Local" class="mb-2" :icon="nolocal.onde_estou === 'Drive-thru' ? 'drive-thru' : 'qrcode'" icon-pos="fa-trash-o">
                    <div class="small">{{nolocal.onde_estou}}<span v-if="nolocal.obs_pedido">: {{nolocal.obs_pedido}}</span></div>
                  </card-info>
                </a>
                <taxa-tempo class="mb-2" ref="taxa" v-else/>
              </div>
            </div>
            <div v-else-if="empresa.empresaAberta">
              <card-info title="Agende seu pedido" class="mb-2" icon="agendar">
                <div class="small text-normal" v-if="empresa.proximo_horario">Abrimos {{ empresa.proximo_horario.label }} às {{ empresa.proximo_horario.horario_inicio }}</div>
                <div class="small text-normal" v-else>Escolha o melhor horário para receber</div>
              </card-info>
            </div>
            <div v-else>
              <card-info :title="empresa.aberto === '0' ? 'Estamos fechados' : 'Fechado no momento'" class="mb-2" icon="agendar">
                <div class="small text-normal" v-if="empresa.pausa_programada">{{empresa.pausa_programada}}</div>
                <div class="small text-normal" v-else-if="empresa.proximo_horario">Abrimos {{ empresa.proximo_horario.label }} às {{ empresa.proximo_horario.horario_inicio }}</div>
                <div class="small text-normal" v-else>Fique a vontade para ver nossos produtos!</div>
              </card-info>
            </div>
            <fidelidade componente="true" class="mb-4" v-if="empresa.fidelidade && !zap"/>
          </div>
          <div class="mb-4" v-if="dados.destaques.length > 0">
            <h3 class="h5 font-weight-bold mb-2">Destaques</h3>
            <carrosell :slides="dados.destaques"/>
          </div>
        </div>
        <div class="container-fluid" v-if="id_theme !== '2'">
          <h3 class="h5 font-weight-bold mb-2">Produtos</h3>
          <div class="form-control pointer d-flex justify-content-between align-items-center mb-2" @click="pesquisar()" style="height: 44px">
            <div>Pesquisar produto</div>
            <icon name="search" size="15" class="text-primary" style="margin-top: -1px"/>
          </div>
          <cardapio :categorias="dados.categorias"/>
        </div>
        <div id="divProdutos" class="mt-3" v-else>
          <div class="container-fluid">
            <h3 class="h5 font-weight-bold mb-2">Produtos</h3>
          </div>
          <categorias component="true"/>
        </div>
        <ads-le-card :class="{'mb-zap': zap && qtdSacola}"/>
      </div>
    </div>

    <div class="fixed-bottom d-md-none border-top shadow-top" v-if="zap && qtdSacola">
      <div class="bg-white">
        <div class="p-3">
          <a href="javascript:" class="btn btn-primary text-white btn-block font-weight-bold py-2 px-3" @click="$emit('openSacola')">
            <div id="sacolaAnimated" class="d-flex justify-content-between align-items-center">
              <div>
                <icon name="sacola" full="true" size="24"/>
              </div>
              <div class="font-weight-bold">
                Ver Sacola
              </div>
              <div>
                <span class="badge badge-light rounded-circle text-primary" style="width: 19px; height: 19px">{{qtdSacola}}</span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopBar from '../../../components/TopBar'
  import Loading from '../../../components/Loading'
  import Cardapio from '../../../components/Cardapio'
  import Categorias from '../../../pages/Categorias'
  import Fidelidade from '../../../pages/Fidelidade'
  import CardInfo from '../../../components/CardInfo'
  import Carrosell from "../../../components/Carrosell";
  import BottomBar from "../../../components/BottomBar";
  import AdsLeCard from "../../../components/AdsLeCard";
  import TaxaTempo from "../../../components/TaxaTempo";
  import Icon from "../../../components/Icon";

  export default {
    name: 'HomeEmpresa',
    components: {Categorias, Fidelidade, TaxaTempo, Icon, AdsLeCard, BottomBar, Carrosell, TopBar, Loading, Cardapio, CardInfo},
    data() {
      return {
        load: false,
        token: localStorage.getItem('token')
      }
    },
    methods: {
      clearSacola() {
        this.$swal({
          text: 'Deseja realmente cancelar seu pedido no local?',
          buttons: ["Não", "Sim"],
          dangerMode: true,
        }).then((r) => {
          if (r) {
            this.load = true;
            this.$store.state.nolocal = { obs_pedido: '', onde_estou: '' };
            this.$store.state.sacola.tipo_pedido = '';
            this.$store.state.sacola.nolocal = null;
            this.$store.state.sacola.origin = this.origin;
            localStorage.setItem('sacola', JSON.stringify(this.$store.state.sacola));
            localStorage.removeItem('nolocal');

            this.$helpers.getCardapioEmpresa(this, this.empresa.token, null, (res) => {
              if (res) {
                this.$swal('Pedido no local cancelado com sucesso!');
                this.load = false;
              }
            });
          }
        });
      },

      messageEntrega() {
        this.$swal("Valor variável baseado na distância do endereço de entrega.");
      },

      pesquisar() {
        this.$router.push('/' + this.empresa.dominio_delivery + '/categorias?search=true')
      }
    },

    created() {
      document.body.classList.remove("modal-open");
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      },

      empresa() {
        return this.$store.state.empresa
      },

      sacola() {
        return this.$store.state.sacola
      },

      nolocal() {
        return this.$store.state.nolocal
      },

      qtdSacola() {
        const qtd = this.$store.state.sacola.produtos.length;
        return qtd < 10 ? qtd : 9;
      },

      zap() {
        return this.$store.state.zap
      },

      dados() {
        return this.$store.state.cardapio
      },

      id_theme() {
        return this.$store.state.empresa.id_theme
      }
    },

    beforeRouteLeave(to, from, next) {
      if (this.$refs.taxa && this.$refs.taxa.opened) {
        this.$refs.taxa.closeModal();

      } else {
        next()
      }
    }
  }
</script>
<style scoped>
  .container-capa {
    position: relative;
    height: 220px;
    z-index: 1;
  }

  .container-logo {
    position: relative;
    z-index: 2;
  }

  .logo-empresa {
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: var(--lecard-primary)!important;
  }

  .img-empresa {
    margin: -72px auto 0;
    border: 6px solid #ffffff;
    width: 115px;
    height: 115px;
    border-radius: 50%;
    background-color: #ffffff;
  }

  .img-empresa img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }

  .text-home {
    background-color: #ffffff;
    padding: 24px 15px;
    margin: -55px auto 0;
    border-radius: 18px;
  }

  .mb-zap {
    margin-bottom: 74px;
  }

  @media (min-width: 768px) {
    .container-capa {
      border: 4px solid #ffffff;
      border-radius: 18px;
      margin: 0 15px;
    }

    .logo-empresa {
      border-radius: 14px;
    }

    .container-logo {
      padding: 0 30px;
    }

    .theme-2 .container-capa, .theme-2 .container-logo {
      margin: auto;
      max-width: 996px;
    }
  }
</style>
